module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "permissionList"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("权限管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("查询权限")])], 1), _vm._v(" "), _c('el-table', {
    staticClass: "permission-list-table",
    attrs: {
      "data": _vm.permissionList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "权限ID",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.permissionsId))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "权限名称",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.permissionsName))])]
      }]
    ])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              _vm.deletePermission(scope.row.permissionsId)
            }
          }
        }, [_vm._v("删除")])]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticClass: "page-control",
    attrs: {
      "layout": "prev, pager, next",
      "total": _vm.permissionListLength
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3d3b14cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/permissions/List.vue
// module id = 755
// module chunks = 1